import { IMaterialLazyResponse } from "../models/IMaterialLazyResponse";
import api from "./api";

export const integrationProjectList = async (params?: any) => {
	const { data } = await api.get("manager/integration/project/", {
		params: params,
	});

	return data;
};

export const integrationGetDisciplineList = async (id: string) => {
	const { data } = await api.get(
		`manager/integration/project/${id}/?material=discipline`
	);

	return data;
};

export const integrationGetThemeList = async (id: string) => {
	const { data } = await api.get(
		`manager/integration/project/${id}/?material=theme`
	);

	return data;
};

export const integrationGetUnityThemeList = async (id: string, params: any) => {
	const { data } = await api.get(`manager/integration/project/${id}/`, {params: params});
	return data;
};

export const integrationGetObjectList = async (
	id: string,
	page: number = 1,
	category: any[] = []
) => {
	const params = {
		"material": "object",
		"page": page,
		"category": category
	}

	const { data } = await api.get(`manager/integration/project/${id}/`, {params: params});
	return data as IMaterialLazyResponse;
};

export const integrationMaterialsList = async (params?: any) => {
	const { data } = await api.post("manager/integration/materials/", params);

	return data;
};

export const integrationImportMaterials = async (params?: any) => {
	const { data } = await api.post("manager/integration/import/", params);

	return data;
};

export const integrationUpdateImportMaterials = async (params?: any) => {
	const { data } = await api.post(
		"manager/integration/update_materials/",
		params
	);

	return data;
};

export const integrationScheduleUpdateImportMaterials = async (
	payload?: any
) => {
	const { data } = await api.post(
		"manager/integration/bulk_update_materials/",
		payload
	);

	return data;
};
